<div class="divisa-card">
  <div class="divisa-card-body">
    <div class="divisa-card-header">
      <img class="divisa-card-img" [src]="divisa.currency.logoUrl" alt="" />
      <div class="title-flex">
        <span class="divisa-name">{{ divisa.currency.code }}</span>
        <span class="divisa-fullname">{{ divisa.currency.code | currencyName : divisa.currency.name }}</span>
      </div>
    </div>
    <div class="divisa-row divisa-card-info">
      <div class="divisa-space-between">
        <span class="dovsa-column divisa-card-fecha">{{
          'SHARED.RATE_AS_OF' | translate
        }}</span>
        <span class="dovsa-column divisa-card-fecha-var">{{
          divisa.updateAt | date : "dd/MM/yyyy"
        }}</span>
      </div>
      <div class="divisa-space-between">
        <span class="dovsa-column divisa-card-label">{{
          'LANDING.PRICE_TABLE.COLUMN_BUY' | translate
        }}:
        </span>
        <span class="dovsa-column divisa-card-label-var"
          >{{ divisa.buy | currency }} MXN</span
        >
      </div>
      <div class="divisa-space-between">
        <span class="dovsa-column divisa-card-label">{{
          'LANDING.PRICE_TABLE.COLUMN_SELL' | translate
        }}:
        </span>
        <span class="dovsa-column divisa-card-label-var"
          >{{ divisa.sell | currency }} MXN</span
        >
      </div>
    </div>

    <button
      mat-raised-button
      color="accent"
      [attr.aria-label]="'HOME_BRANCHES.RESERVE_BUTTON' | translate"
      class="button auto"
      (click)="openDialog()"
    >
      {{ 'HOME_BRANCHES.RESERVE_BUTTON' | translate }}
      <mat-icon iconPositionEnd svgIcon="payments"></mat-icon>
    </button>
  </div>
</div>
